/* KenJo flow v2: section clicks and shared route prefixes through the existing GA4 destination. */
(function (global) {
  'use strict';
  function text(value) { return String(value || '').replace(/\s+/g, ' ').trim().slice(0, 100); }
  function internalPath(value, origin) {
    try {
      var url = new URL(value, origin);
      if (!/^https?:$/.test(url.protocol) || !/(^|\.)kenjosabers\.(nl|com)$/.test(url.hostname)) return '';
      // Query strings can contain personal data. Keep only the path.
      if (/^\/cdn\//.test(url.pathname)) return '';
      return url.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '') || '/';
    } catch (_) { return ''; }
  }
  function pageType(path) {
    if (path === '/') return 'home';
    if (/\/products\//.test(path)) return 'product';
    if (/^\/collections(?:\/|$)/.test(path)) return 'collection';
    if (/^\/blogs(?:\/|$)/.test(path)) return 'blog';
    if (/^\/cart(?:\/|$)/.test(path)) return 'cart';
    return 'other';
  }
  function testModeEnabled(win) {
    var choice = new URLSearchParams(win.location.search).get('kenjo_flow_test');
    try {
      if (choice === '0') { win.sessionStorage.removeItem('kenjo_flow_test'); win.sessionStorage.removeItem('kenjo_flow_route_v2_test'); win.sessionStorage.removeItem('kenjo_flow_pending_v3_test'); return false; }
      if (choice === '1') win.sessionStorage.setItem('kenjo_flow_test', '1');
      return choice === '1' || win.sessionStorage.getItem('kenjo_flow_test') === '1';
    } catch (_) { return choice === '1'; }
  }
  // A route key describes a shared sequence of content, never a visitor identity.
  // Two hashes provide a compact 48-bit key; the report also checks key/ref conflicts.
  function routeKey(value) {
    var a = 2166136261, b = 2654435769, alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
    value = String(value);
    for (var i = 0; i < value.length; i++) { a = Math.imul(a ^ value.charCodeAt(i), 16777619); b = Math.imul(b ^ value.charCodeAt(i), 2246822519); }
    var bytes = [(a >>> 24) & 255, (a >>> 16) & 255, (a >>> 8) & 255, a & 255, (b >>> 8) & 255, b & 255], result = '';
    for (var j = 0; j < 6; j += 3) { var n = (bytes[j] << 16) | (bytes[j + 1] << 8) | bytes[j + 2]; result += alphabet[(n >>> 18) & 63] + alphabet[(n >>> 12) & 63] + alphabet[(n >>> 6) & 63] + alphabet[n & 63]; }
    return result;
  }
  function routeState(storage, sid, now, storageKey) {
    try {
      var old = JSON.parse(storage.getItem(storageKey || 'kenjo_flow_route_v2_live') || 'null');
      if (old && old.sid === String(sid) && now >= old.at && now - old.at < 1800000 && /^(root|[A-Za-z0-9_-]{8})$/.test(old.path)) return old;
    } catch (_) {}
    return {sid: String(sid), path: 'root', at: now, depth: 0};
  }
  function appendRoute(state, ref, kind, label, now) {
    var parent = state.path, id = routeKey(ref), path = routeKey(parent + '>' + ref);
    state.path = path; state.at = now; state.depth = (state.depth || 0) + 1;
    return {flow_parent: parent, flow_path: path, flow_node_id: id, flow_node_type: text(kind), flow_node_label: text(label), flow_node_ref: text(ref), flow_basis: 'ga4_session'};
  }
  function start(win, doc, config) {
    if (!config || !config.enabled || win.__kenjoFlowV1 || (win.Shopify && win.Shopify.designMode)) return null;
    var testMode = testModeEnabled(win);
    if (config.testOnly && !testMode) return null;
    var sequence = 0, contextSent = false, ready = false, loadedConsentApi = false, stopped = false;
    var route = null, sessionRequested = false, waitingContext = false;
    var routeStorageKey = 'kenjo_flow_route_v2_' + (testMode ? 'test' : 'live');
    var pendingStorageKey = 'kenjo_flow_pending_v3_' + (testMode ? 'test' : 'live');
    var pageInstance = 'p' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
    var sourcePath = internalPath(win.location.href, win.location.origin);
    if (String(config.pageId || '').indexOf('path:') === 0) config.pageId = 'path:' + sourcePath;
    var root = doc.documentElement;
    var tracker = { version: '20261023-v3', stop: function () { stopped = true; doc.removeEventListener('click', click, true); ready = false; } };
    win.__kenjoFlowV1 = tracker;
    function allowed() {
      try { return !stopped && ready && win.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
      catch (_) { return false; }
    }
    function transmit(name, data) {
      win.gtag('event', name, data);
      if (testMode) root.setAttribute('data-kenjo-flow-last', JSON.stringify({ name: name, parameters: data }));
    }
    function flushPending(includeCurrentPage) {
      if (!allowed() || !route || typeof win.gtag !== 'function') return;
      try {
        var list = JSON.parse(win.sessionStorage.getItem(pendingStorageKey) || '[]'), keep = [], send = [];
        list.forEach(function (entry) {
          if (entry.sid !== route.sid || Date.now() - entry.at > 1800000 || Date.now() < entry.at) return;
          if (entry.page === pageInstance && !includeCurrentPage) keep.push(entry); else send.push(entry);
        });
        if (keep.length) win.sessionStorage.setItem(pendingStorageKey, JSON.stringify(keep)); else win.sessionStorage.removeItem(pendingStorageKey);
        send.forEach(function (entry) { transmit(entry.name, entry.data); });
      } catch (_) {}
    }
    function emit(name, values, delivery) {
      if (!allowed() || typeof win.gtag !== 'function') return false;
      var data = {
        measurement_version: tracker.version,
        interaction_id: pageInstance + '-' + (++sequence),
        source_page_id: text(config.pageId),
        source_page_type: text(config.pageType || pageType(sourcePath)),
        source_path: text(sourcePath),
        flow_mode: testMode ? 'test' : 'live',
        page_location: win.location.origin + win.location.pathname
      };
      Object.keys(values || {}).forEach(function (key) { if (values[key] !== '' && values[key] !== null && values[key] !== undefined) data[key] = text(values[key]); });
      data.send_to = config.measurementId;
      data.transport_type = 'beacon';
      if (testMode) data.debug_mode = true;
      try {
        if (delivery && route && config.navigationDelivery === 'next_page') {
          var list = JSON.parse(win.sessionStorage.getItem(pendingStorageKey) || '[]');
          list.push({ name: name, data: data, sid: route.sid, at: Date.now(), page: pageInstance });
          win.sessionStorage.setItem(pendingStorageKey, JSON.stringify(list.slice(-8)));
          if (testMode) root.setAttribute('data-kenjo-flow-last', JSON.stringify({ name: name, parameters: data, delivery: 'next_page' }));
          Promise.resolve().then(function () { if (delivery.event.defaultPrevented && win.location.href === delivery.href) flushPending(true); });
          win.setTimeout(function () { if (win.location.href === delivery.href) flushPending(true); }, 1500);
        } else transmit(name, data);
        return true;
      } catch (_) { try { transmit(name, data); return true; } catch (_) { return false; } }
    }
    function routeFields(ref, kind, name) {
      if (!route || !allowed()) return {flow_basis: 'unavailable'};
      var fields = appendRoute(route, ref, kind, name, Date.now());
      fields.flow_mode = testMode ? 'test' : 'live';
      try { win.sessionStorage.setItem(routeStorageKey, JSON.stringify(route)); } catch (_) { return {flow_basis: 'storage_unavailable', flow_mode: testMode ? 'test' : 'live'}; }
      return fields;
    }
    function getSession() {
      if (sessionRequested || !allowed() || typeof win.gtag !== 'function') return;
      sessionRequested = true;
      try {
        win.gtag('get', config.measurementId, 'session_id', function (sid) {
          if (!allowed() || !sid) return;
          try { route = routeState(win.sessionStorage, sid, Date.now(), routeStorageKey); } catch (_) { return; }
          flushPending(false);
          if (waitingContext) { waitingContext = false; context(); }
        });
      } catch (_) {}
    }
    function context() {
      if (!allowed()) { if (ready) { route = null; contextSent = false; sessionRequested = false; waitingContext = false; try { win.sessionStorage.removeItem(routeStorageKey); win.sessionStorage.removeItem(pendingStorageKey); } catch (_) {} } return; }
      if (route && Date.now() - route.at >= 1800000) { route = null; contextSent = false; sessionRequested = false; }
      if (!contextSent && route) contextSent = emit('kenjo_page_context', routeFields('page:' + config.pageId, config.pageType, config.pageTitle || config.pageId));
      else if (!contextSent) { waitingContext = true; getSession(); }
    }
    function prepareConsent() {
      if (stopped) return;
      if (win.Shopify && win.Shopify.customerPrivacy && typeof win.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function') {
        ready = true; context(); return;
      }
      if (!loadedConsentApi && win.Shopify && typeof win.Shopify.loadFeatures === 'function') {
        loadedConsentApi = true;
        win.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
          if (!error) { ready = true; context(); }
        });
      }
    }
    function label(el) {
      var by = el.getAttribute('aria-labelledby'), named = by && doc.getElementById(by);
      var card = el.closest('.grid-product,.qq-product,[data-product-id]');
      var title = card && card.querySelector('.grid-product__title,.qq-product-title,[data-product-title]');
      var value = (title && title.textContent) || el.getAttribute('aria-label') || (named && named.textContent) || el.textContent || (el.querySelector('img') || {}).alt;
      return text(String(value || '').replace(/<[^>]*>/g, ' ').replace(/<[^>]*$/, ' '));
    }
    function menuLabel(li) {
      var children = Array.prototype.slice.call(li.children || []);
      for (var i = 0; i < children.length; i++) {
        if (children[i].matches('a,button')) return children[i];
        if (children[i].matches('.mobile-nav__has-sublist,.mobile-nav__child-item')) {
          var nested = children[i].querySelector('a,button'); if (nested) return nested;
        }
      }
      return null;
    }
    function menuPath(el, nav) {
      var parts = [label(el)], current = el.parentElement;
      if (el.matches('.site-nav__dropdown-link:not(.site-nav__dropdown-link--top-level)')) {
        var previous = current.previousElementSibling;
        while (previous && !previous.classList.contains('h5')) previous = previous.previousElementSibling;
        if (previous && previous.querySelector('a')) parts.unshift(label(previous.querySelector('a')));
      }
      while (current && current !== nav) {
        if (current.tagName === 'LI') {
          var parent = menuLabel(current);
          if (parent && parent !== el && label(parent) !== parts[0]) parts.unshift(label(parent));
        }
        current = current.parentElement;
      }
      return text(parts.filter(Boolean).join(' > '));
    }
    function click(event) {
      if (!event.isTrusted || !allowed()) return;
      var started = win.performance.now();
      try {
        var el = event.target && event.target.closest ? event.target.closest('a[href],button') : null;
        if (!el && event.target && event.target.closest) el = event.target.closest('input[type="submit"]');
        if (!el) return;
        var nav = el.closest('ul.site-navigation,ul.mobile-nav');
        var scope = el.closest('[data-kenjo-source-type]') || el.closest('[id^="shopify-section-"]');
        var kind = scope && scope.getAttribute('data-kenjo-source-type');
        var action = 'navigate', sectionName = scope && scope.getAttribute('data-kenjo-source-name');
        var instance = scope && scope.getAttribute('data-kenjo-source-instance');
        var sectionId = scope && scope.getAttribute('data-kenjo-source-key');
        var path = '', surface = '';
        var productForm = el.closest('form[action*="/cart/add"]');
        var buyButton = productForm && el.matches('button[type="submit"],button[name="add"],input[type="submit"],[data-add-to-cart]');
        if (nav && !el.closest('.mobile-nav__item--secondary')) {
          kind = 'main_menu'; sectionName = 'Hoofdmenu'; instance = sectionId = 'main_menu';
          path = menuPath(el, nav); surface = nav.classList.contains('mobile-nav') ? 'mobile' : 'desktop';
          if (el.tagName === 'BUTTON') action = 'menu_toggle';
        } else if (kind === 'banner') {
          if (!el.matches('a[class*="slideshow-pro-button-"]')) return;
        } else if (kind === 'categories') {
          if (el.closest('.qq-collection-filters')) action = 'category_filter';
          else if (el.closest('.qq-products')) action = 'product_click';
          else if (el.closest('.qq-section-button')) action = 'collection_link';
          else return;
        } else if (scope && (!el.closest('form') || buyButton)) {
          // Generic section links also work after section reordering, duplication and AJAX rendering.
          kind = kind || scope.getAttribute('data-section-type') || (scope.querySelector('[data-section-type]') || {getAttribute: function () { return null; }}).getAttribute('data-section-type') || 'section';
          var nativeSection = el.closest('[id^="shopify-section-"]');
          instance = instance || (nativeSection || scope).id.replace(/^shopify-section-/, ''); sectionId = instance;
          if (el.closest('#CollectionGrid')) { kind = 'product_grid'; action = 'product_click'; }
          if (scope.id === 'shopify-section-footer') { kind = 'footer'; sectionName = 'Voettekst'; }
          if (scope.id === 'shopify-section-header') { kind = 'header'; sectionName = 'Kop van de pagina'; }
          if (el.tagName === 'BUTTON') action = el.hasAttribute('aria-expanded') ? 'toggle_content' : 'button_click';
          if (buyButton) { action = 'add_to_cart'; kind = 'product_form'; sectionName = sectionName || 'Productinformatie'; }
          if (el.hasAttribute && el.hasAttribute('data-finder-tab')) action = 'finder_tab';
        } else return;
        var rawHref = el.getAttribute('href'), destination = rawHref ? internalPath(rawHref, win.location.href) : '';
        if (el.tagName === 'A' && (!destination || !rawHref || rawHref === '#')) return;
        var target = el.closest('[data-kenjo-target-id]');
        var elementLabel = buyButton ? 'In winkelwagen' : label(el);
        if (!elementLabel && kind === 'categories') {
          var card = el.closest('.qq-product');
          var title = card && card.querySelector('.qq-product-title');
          if (title) elementLabel = text(title.textContent);
        }
        if (!sectionName && scope) {
          var heading = scope.querySelector('h1,h2,h3,.h1,.h2,.h3,.qq-title');
          if (heading) sectionName = text(heading.textContent);
        }
        context();
        var fields = {
          interaction_type: action,
          section_type: kind,
          section_instance_id: instance || kind,
          section_name: sectionName || kind,
          element_label: elementLabel,
          target_path: destination,
          menu_path: path,
          menu_surface: surface,
          selected_category: action === 'category_filter' ? destination : ''
        };
        if ((destination || buyButton || action === 'finder_tab') && action !== 'menu_toggle') {
          var choice = buyButton ? config.pageId : action === 'finder_tab' ? el.getAttribute('data-finder-tab') : destination;
          var ref = 'ui:' + routeKey(instance || kind) + ':' + action + ':' + choice;
          var nodeName = kind === 'main_menu' ? 'Hoofdmenu · ' + (path || elementLabel) : (sectionName || kind) + ' · ' + elementLabel;
          Object.assign(fields, routeFields(ref, kind === 'main_menu' ? 'menu' : 'section', nodeName));
        }
        var delivery = null;
        if (el.tagName === 'A' && destination && action !== 'category_filter' && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && (!event.button || event.button === 0) && el.getAttribute('target') !== '_blank') {
          var targetUrl = new URL(rawHref, win.location.href);
          if (targetUrl.origin === win.location.origin && rawHref.charAt(0) !== '#') delivery = { event: event, href: win.location.href };
        }
        emit('kenjo_ui_interaction', fields, delivery);
      } catch (error) {
        if (testMode) root.setAttribute('data-kenjo-flow-error', text(error && error.message));
        // Tracking failures must not cancel navigation, filters, or other UI handlers.
      } finally {
        if (testMode) root.setAttribute('data-kenjo-flow-handler-ms', (win.performance.now() - started).toFixed(2));
      }
    }
    doc.addEventListener('click', click, true);
    doc.addEventListener('visitorConsentCollected', function () { prepareConsent(); context(); });
    doc.addEventListener('consentmoSignal_onLoad', function () { prepareConsent(); context(); });
    doc.addEventListener('consentmoSignal', function () { prepareConsent(); context(); });
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', prepareConsent, { once: true });
    win.addEventListener('load', context, { once: true });
    win.addEventListener('pageshow', function (event) {
      if (event.persisted && !stopped) { route = null; contextSent = false; sessionRequested = false; context(); }
    });
    prepareConsent();
    if (testMode) root.setAttribute('data-kenjo-flow-ready', tracker.version);
    return tracker;
  }
  var api = { internalPath: internalPath, pageType: pageType, testModeEnabled: testModeEnabled, routeKey: routeKey, routeState: routeState, appendRoute: appendRoute, start: start };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (global) global.KenjoFlow = api;
  if (global && global.document) {
    var configElement = global.document.getElementById('kenjo-flow-config');
    if (configElement) {
      try { start(global, global.document, JSON.parse(configElement.textContent)); } catch (_) {}
    }
  }
})(typeof window === 'undefined' ? null : window);
